import { createContext, useContext, useState, useEffect } from 'react'
import { analyticsAPI } from '../services/api'

const DashboardContext = createContext({})

export function DashboardProvider({ children }) {
  const [stats, setStats] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  const loadDashboardData = async () => {
    try {
      setLoading(true)
      console.log('Loading dashboard data...')
      const response = await analyticsAPI.getDashboard()
      console.log('Dashboard API response:', response.data)
      setStats(response.data)
      setError('')
    } catch (err) {
      console.error('Failed to load dashboard data:', err)
      
      // If it's a 401 error, don't retry - let the interceptor handle redirect
      if (err.response?.status === 401) {
        console.log('Authentication error - redirecting will be handled by interceptor')
        return
      }
      
      setError('Failed to load dashboard data')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    loadDashboardData()
  }, [])

  const refreshStats = () => {
    loadDashboardData()
  }

  return (
    <DashboardContext.Provider 
      value={{ 
        stats, 
        loading, 
        error, 
        refreshStats 
      }}
    >
      {children}
    </DashboardContext.Provider>
  )
}

export function useDashboard() {
  const context = useContext(DashboardContext)
  if (context === undefined) {
    throw new Error('useDashboard must be used within a DashboardProvider')
  }
  return context
}